export default __webpack_public_path__ + "static/media/single-video-icon.d8118780.png";